import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import kr from "./locales/ko-KR/common.json";
import en from "./locales/en-US/common.json";
import jp from "./locales/ja-JP/common.json";
import cn from "./locales/zh-CN/common.json";
import tw from "./locales/zh-TW/common.json";

i18n.use(initReactI18next).init({
  lng: "koKr", // 기본 언어 설정
  fallbackLng: "koKr", // 대체 언어 설정 (기본 언어로 사용)
  resources: {
    "koKr": { translation: kr },
    "enUs": { translation: en },
    "jaJp": { translation: jp },
    "zhCn": { translation: cn },
    "zhTw": { translation: tw },
  },

  // template literal 방식이라고 생각하면 편하다.
  // ex: t('안녕 %{하세요}')

  // interpolation: {
  //   prefix: "%{",
  //   suffix: "}",
  // },

  returnNull: false,
  returnEmptyString: false,
  keySeparator: false,
  nsSeparator: false,
  parseMissingKeyHandler(key, defaultValue) {
    console.warn("Missing i18n key:", key, defaultValue);
    const keySeparator = "~~";
    const value = key.includes(keySeparator) ? key.split(keySeparator)[1] : key;
    return value;
  },
});

export default i18n;
